
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateTaskScheduledForm } from '@/services/Backup/forms/CreateBackupForm';
import {
  BackupCreationType,
  BackupRepositoryInterface,
  TaskScheduleRepositoryInterface,
} from '@/services/Backup/interfaces';
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { BackupScheduleRepositoryInterface } from '../../../services/Backup/interfaces/index';
import BackupRepoPicker from "@/components/backups/BackupRepoPicker.vue";
import WebsitePicker from "@/components/website/WebsitePicker.vue";
import ServerPicker from "@/components/server/ServerPicker.vue";
import BackupServerPicker from "@/components/backups/BackupServerPicker.vue";
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  inject: [
    'taskScheduleRepository',
  ],
  components: {
    BackupServerPicker,
    ServerPicker,
    WebsitePicker,
    BackupRepoPicker,
    PageHeader,
  },
})
export default class CreateTaskSchedule extends Vue {
  public types = [
    'Backup',
    'Forget',
    'Prune'
  ];

  public taskScheduleRepository: TaskScheduleRepositoryInterface;

  public isLoading: boolean = false;
  public scheduledBackupForm: WPXFormValue<CreateTaskScheduledForm> = new WPXFormValue(CreateTaskScheduledForm);

  public async createScheduledTask(): Promise<void> {
    try {
      this.isLoading = true;
      await this.taskScheduleRepository.createBackupSchedule({
        targetServerId: this.scheduledBackupForm.data.targetServerId,
        type: this.scheduledBackupForm.data.type,
        intervalDays: Number(this.scheduledBackupForm.data.intervalDays),
        retries: Number(this.scheduledBackupForm.data.retries),
        runAtHour: Number(this.scheduledBackupForm.data.runAtHour),
        runAtMinute: Number(this.scheduledBackupForm.data.runAtMinute),
      });

      this.$infoDialog.show(`Scheduled task creation started!`);
      this.$router.push({ name: "schedule_list" })
    } catch (err) {
      this.onError(err);
    } finally {
      this.isLoading = false;
    }
  }

  private onError(err: unknown): void {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}
